.screen {
	max-width: var(--screen-max);
	margin: 0 auto;
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

/* Sticks to the top of the shell's scroll area, so adding stays in reach
   down a long list. */
.addBar {
	position: sticky;
	top: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
	margin: 0 calc(-1 * var(--space-5));
	padding: var(--space-2) var(--space-5);
	background: var(--surface-page);
}

.add {
	display: flex;
	gap: var(--space-2);
}

.addInput {
	flex: 1;
	min-width: 0;
	height: var(--control-h);
	padding: 0 var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
}

.addInput:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

.addInput:disabled {
	opacity: 0.6;
}

.addButton {
	flex: none;
	width: var(--control-h);
	height: var(--control-h);
	border: none;
	border-radius: var(--radius-md);
	background: var(--accent-sage);
	color: #fff;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.addButton:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.notice {
	margin: 0;
	color: var(--ink-muted);
	font-size: 0.875rem;
}

.list {
	list-style: none;
	margin: 0;
	padding: var(--space-2) 0;
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
}

.section {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.sectionHead {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: var(--space-3);
}

.heading {
	margin: 0;
	color: var(--ink-muted);
	font-family: var(--font-ui);
	font-size: 0.875rem;
	font-weight: 600;
}

.sectionAction {
	padding: 0;
	border: none;
	background: none;
	color: var(--ink-muted);
	font: inherit;
	font-size: 0.875rem;
	text-decoration: underline;
	cursor: pointer;
}

.sectionAction:hover:not(:disabled) {
	color: var(--ink);
}

.sectionAction:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.empty {
	color: var(--ink-muted);
	text-align: center;
	padding: var(--space-6) var(--space-4);
	margin: 0;
}

.retry {
	background: none;
	border: none;
	color: var(--accent-sage);
	cursor: pointer;
	font: inherit;
	padding: 0;
	text-decoration: underline;
}
